(() => {
  'use strict';
  if (window.DrpenxCartFinal) return;
  const source = document.querySelector('[data-cf-cart-config]');
  let config;
  try { config = JSON.parse(source?.textContent || ''); } catch { return; }
  const drawer = document.querySelector('[data-cf-drawer]');
  if (!config?.routes?.cart || !config.routes.change || !config.routes.update || !config.routes.add || !drawer) return;
  const feedback = document.querySelector('[data-cf-feedback]');
  const feedbackHome = feedback?.parentElement;
  const feedbackNext = feedback?.nextSibling;
  const strings = config.strings || {};
  const number = (value, fallback = 0) => Number.isFinite(Number(value)) ? Number(value) : fallback;
  const surfaces = () => [...document.querySelectorAll('[data-cf-surface]')];
  const readJSON = node => { try { return JSON.parse(node?.textContent || ''); } catch { return null; } };
  const isCart = cart => Array.isArray(cart?.items) && Number.isFinite(Number(cart.item_count)) && Number.isFinite(Number(cart.total_price));
  const canonical = value => Array.isArray(value) ? value.map(canonical) : value && typeof value === 'object' ? Object.fromEntries(Object.keys(value).sort().map(key => [key, canonical(value[key])])) : value;
  const lineIdentity = item => item ? JSON.stringify([String(item.variant_id || item.id || ''), canonical(item.properties || {}), String(item.selling_plan_allocation?.selling_plan?.id || '')]) : null;
  let cart = surfaces().map(surface => readJSON(surface.querySelector('[data-cf-cart-data]'))).find(isCart) || null;
  let queue = Promise.resolve();
  let busy = false;
  let scrollState = null;
  let opener = null;
  let openRequest = 0;
  let removal = null;
  let undoPending = false;
  let stickyFrame = 0;
  let stickyLayout = { visible: false, height: 0 };
  let lifecycleTimer = 0;
  let lifecyclePending = false;
  let lifecycleDirty = false;
  const disabled = new WeakMap();
  const quantityRequests = new Map();
  const adding = new WeakSet();
  const text = (key, fallback = '') => String(strings[key] || fallback);
  const substituteCount = count => (count === 1 ? text('cartCountOne', '1 item') : text('cartCount', config.cartCountTemplate || '')).replace(/__COUNT__|\[count\]|\{count\}/g, String(count));
  const endpoint = (name, json = false) => {
    const url = new URL(config.routes[name], location.origin);
    if (url.origin !== location.origin) throw new Error(text('loadError'));
    if (json && !url.pathname.endsWith('.js')) url.pathname = url.pathname.replace(/\/$/, '') + '.js';
    return url;
  };
  const sectionIds = () => [...new Set(surfaces().map(surface => surface.dataset.cfSectionId || (surface.dataset.cfSurface === 'drawer' ? config.drawerSection : '')).filter(Boolean))].slice(0, 5);
  const sectionContext = () => endpoint('cart').pathname;
  const setContent = (selector, message, hidden = false, scope = document) => scope.querySelectorAll(selector).forEach(node => { node.textContent = message; node.hidden = hidden || !message; node.removeAttribute('data-cf-display-warning'); });
  function placeFeedback() {
    if (!feedback) return;
    const slot = drawer.open ? drawer.querySelector('[data-cf-feedback-slot]') : document.querySelector('[data-cf-surface="page"] [data-cf-feedback-slot]');
    if (slot) {
      if (feedback.parentElement !== slot) slot.append(feedback);
    } else if (!drawer.open && (!feedback.isConnected || drawer.contains(feedback))) {
      const parent = feedbackHome?.isConnected ? feedbackHome : document.body;
      parent.insertBefore(feedback, feedbackNext?.parentNode === parent ? feedbackNext : null);
    }
  }
  const feedbackVisibility = () => {
    placeFeedback();
    document.querySelectorAll('[data-cf-feedback]').forEach(node => { node.hidden = drawer.open && !drawer.contains(node) || ![...node.querySelectorAll('[data-cf-status],[data-cf-error]')].some(copy => !copy.hidden && copy.textContent.trim()); });
    if (feedback && drawer.open && drawer.contains(feedback) && !feedback.hidden) {
      setContent('[data-cf-drawer-status],[data-cf-drawer-error]', '', true, drawer);
      drawer.querySelectorAll('[data-cf-undo]').forEach(button => { if (!feedback.contains(button)) button.hidden = true; });
    }
  };
  const announce = message => { setContent('[data-cf-status]', message); if (drawer.open) setContent('[data-cf-drawer-status]', message); feedbackVisibility(); };
  const clearErrors = () => {
    setContent('[data-cf-error],[data-cf-drawer-error],[data-cf-add-error]', '', true);
    document.querySelectorAll('[data-cf-retry]').forEach(button => { button.hidden = true; });
    feedbackVisibility();
  };
  const showError = (error, form) => {
    const message = String(error?.description || error?.message || text('updateError', text('loadError')));
    setContent('[data-cf-error]', message);
    if (drawer.open) setContent('[data-cf-drawer-error]', message);
    if (form) {
      let node = form.querySelector('[data-cf-add-error]');
      if (!node) { node = document.createElement('p'); node.className = 'form-feedback'; node.dataset.cfAddError = ''; node.setAttribute('role', 'alert'); form.append(node); }
      node.textContent = message; node.hidden = !message; node.removeAttribute('data-cf-display-warning');
    }
    feedbackVisibility();
  };
  function appendCartFallback(form, displayWarning = false) {
    const targets = [...document.querySelectorAll('[data-cf-error]'), ...(drawer.open ? drawer.querySelectorAll('[data-cf-drawer-error]') : []), ...(form ? form.querySelectorAll('[data-cf-add-error]') : [])];
    targets.forEach(node => {
      if (node.hidden || !node.textContent) return;
      if (displayWarning) node.dataset.cfDisplayWarning = '';
      if (node.querySelector('[data-cf-view-cart]') || !text('viewCart')) return;
      const link = document.createElement('a');
      link.href = endpoint('cart').href; link.dataset.cfViewCart = ''; link.textContent = text('viewCart');
      link.style.textDecoration = 'underline'; link.style.textUnderlineOffset = '3px';
      node.append(document.createTextNode(' '), link);
    });
    if (drawer.open) drawer.querySelectorAll('[data-cf-retry]').forEach(button => { button.hidden = false; });
  }
  const findQuantity = key => [...document.querySelectorAll('[data-cf-quantity]')].find(input => input.dataset.cfKey === key);
  const rules = input => ({ min: Math.max(1, number(input.min || input.dataset.min, 1)), step: Math.max(1, number(input.step || input.dataset.increment, 1)), max: input.max === '' || input.max == null ? Infinity : number(input.max, Infinity) });
  function validQuantity(input, value) {
    const rule = rules(input);
    return Number.isInteger(value) && value >= rule.min && value <= rule.max && (value - rule.min) % rule.step === 0;
  }
  function syncControls() {
    surfaces().forEach(surface => {
      const stale = surface.dataset.cfStale === 'true';
      surface.setAttribute('aria-busy', String(busy));
      surface.querySelectorAll('button,input,select,textarea').forEach(control => {
        if (control.matches('[data-cf-close],[data-cf-retry],[data-cf-dismiss]')) return;
        if (busy || stale) {
          if (!disabled.has(control)) disabled.set(control, control.disabled);
          control.disabled = true;
        } else if (disabled.has(control)) {
          control.disabled = disabled.get(control); disabled.delete(control);
        }
      });
    });
    document.querySelectorAll('[data-cf-adjust]').forEach(button => {
      const input = findQuantity(button.dataset.cfKey);
      if (!input || busy || button.closest('[data-cf-stale="true"]')) return;
      const rule = rules(input), value = number(input.value);
      button.disabled = Number(button.dataset.cfAdjust) < 0 ? value <= rule.min : value + rule.step > rule.max;
    });
    document.querySelectorAll('[data-cf-undo]').forEach(button => {
      const duplicate = feedback && drawer.open && drawer.contains(feedback) && !feedback.hidden && drawer.contains(button) && !feedback.contains(button);
      button.hidden = !removal || Boolean(duplicate); button.disabled = busy;
    });
  }
  const setBusy = value => { busy = value; document.documentElement.dataset.cfCartBusy = String(value); syncControls(); };
  const enqueue = operation => {
    const result = queue.then(operation, operation);
    queue = result.catch(() => {});
    return result;
  };
  async function request(url, options = {}) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal, headers: { Accept: 'application/json', ...options.headers } });
      let data;
      try { data = await response.json(); } catch { const error = new Error(text('loadError')); error.uncertain = true; throw error; }
      if (!response.ok || data.status >= 400 || data.errors) {
        const error = new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : typeof data.errors === 'string' ? data.errors : text('updateError'));
        error.status = response.status; error.uncertain = response.status === 400; throw error;
      }
      return data;
    } catch (error) {
      if (!error.status || error.uncertain) { error.uncertain = true; error.message = options.method === 'POST' ? text('updateError') : text('loadError'); }
      throw error;
    } finally { clearTimeout(timer); }
  }
  const getCart = async () => {
    const actual = await request(endpoint('cart', true));
    if (!isCart(actual)) throw new Error(text('loadError'));
    return actual;
  };
  const getSections = () => {
    const url = endpoint('cart'); url.searchParams.set('sections', sectionIds().join(','));
    return request(url, { headers: { Accept: 'text/html' } });
  };
  const post = (name, payload) => {
    const ids = sectionIds();
    if (payload instanceof FormData) {
      payload.set('sections', ids.join(',')); payload.set('sections_url', sectionContext());
      return request(endpoint(name, true), { method: 'POST', body: payload });
    }
    return request(endpoint(name, true), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...payload, sections: ids, sections_url: sectionContext() }) });
  };
  function synchronizeActual(actual, origin) {
    cart = actual;
    const count = number(actual.item_count);
    document.body.dataset.drxCartCount = String(count);
    document.body.dataset.drxCartValue = String(number(actual.total_price) / 100);
    document.body.dataset.drxCurrency = actual.currency || document.body.dataset.drxCurrency || '';
    document.body.classList.toggle('cf-cart-empty', count === 0);
    document.querySelectorAll('[data-home-cart-count]').forEach(node => { node.textContent = substituteCount(count) || String(count); });
    document.querySelectorAll('[data-cf-count-badge]').forEach(node => { node.textContent = String(count); node.hidden = count === 0; });
    setContent('[data-cf-title-count]', substituteCount(count) || String(count));
    const detail = { cart: actual, source: origin };
    document.dispatchEvent(new CustomEvent('cart:change', { detail }));
    document.dispatchEvent(new CustomEvent('cart:updated', { detail }));
    scheduleSticky();
  }
  function replacementFor(surface, sections, actual) {
    const id = surface.dataset.cfSectionId || (surface.dataset.cfSurface === 'drawer' ? config.drawerSection : '');
    const html = sections?.[id];
    if (typeof html !== 'string' || !html.trim()) return null;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const replacement = [...parsed.querySelectorAll('[data-cf-surface]')].find(node => node.dataset.cfSurface === surface.dataset.cfSurface && (node.dataset.cfSectionId || id) === id);
    if (!replacement || number(replacement.dataset.cfCount, -1) !== number(actual.item_count) || number(replacement.dataset.cfTotal, -1) !== number(actual.total_price) || !sameCart(actual, readJSON(replacement.querySelector('[data-cf-cart-data]')))) return null;
    replacement.removeAttribute('data-cf-stale');
    return replacement;
  }
  function sameCart(actual, rendered) {
    if (!isCart(rendered) || actual.items.length !== rendered.items.length) return false;
    const sharedNumbersEqual = (left, right, keys) => keys.every(key => left[key] == null || right[key] == null || Number(left[key]) === Number(right[key]));
    const discounts = values => values.map(value => {
      const application = value.discount_application || value;
      return [String(application.title || ''), String(application.type || ''), Number(value.amount ?? value.total_allocated_amount ?? 0)];
    });
    const sharedDiscountsEqual = (left, right, keys) => keys.every(key => !Array.isArray(left[key]) || !Array.isArray(right[key]) || JSON.stringify(discounts(left[key])) === JSON.stringify(discounts(right[key])));
    const currency = value => typeof value === 'object' ? value?.iso_code : value;
    if (actual.currency && rendered.currency && currency(actual.currency) !== currency(rendered.currency)) return false;
    if (!sharedNumbersEqual(actual, rendered, ['item_count', 'total_price', 'items_subtotal_price', 'total_discount']) || !sharedDiscountsEqual(actual, rendered, ['cart_level_discount_applications'])) return false;
    return actual.items.every((item, index) => {
      const other = rendered.items[index];
      return String(item.key || '') === String(other.key || '') && lineIdentity(item) === lineIdentity(other) && Number(item.quantity) === Number(other.quantity) && sharedNumbersEqual(item, other, ['price', 'original_price', 'final_price', 'line_price', 'original_line_price', 'final_line_price']) && sharedDiscountsEqual(item, other, ['line_level_discount_allocations', 'discount_allocations']);
    });
  }
  async function renderActual(actual, suppliedSections, origin) {
    let sections = suppliedSections;
    if (!surfaces().every(surface => replacementFor(surface, sections, actual))) sections = await getSections();
    const replacements = surfaces().map(surface => ({ surface, replacement: replacementFor(surface, sections, actual) }));
    if (replacements.some(item => !item.replacement)) {
      surfaces().forEach(surface => { surface.dataset.cfStale = 'true'; });
      synchronizeActual(actual, origin);
      throw new Error(text('loadError'));
    }
    const positions = replacements.map(({ surface, replacement }) => ({
      replacement,
      bodies: [...surface.querySelectorAll('.cf-cart-drawer__body')].map(node => ({ top: node.scrollTop, left: node.scrollLeft })),
      rails: [...surface.querySelectorAll('.reco-rail[id]')].map(node => ({ id: node.id, top: node.scrollTop, left: node.scrollLeft }))
    }));
    if (feedback && replacements.some(({ surface }) => surface.contains(feedback))) document.createDocumentFragment().append(feedback);
    replacements.forEach(({ surface, replacement }) => surface.replaceWith(replacement));
    placeFeedback();
    const restorePositions = () => positions.forEach(({ replacement, bodies, rails }) => {
      if (!replacement.isConnected) return;
      replacement.querySelectorAll('.cf-cart-drawer__body').forEach((node, index) => { if (bodies[index]) { node.scrollTop = bodies[index].top; node.scrollLeft = bodies[index].left; } });
      rails.forEach(position => { const node = [...replacement.querySelectorAll('.reco-rail[id]')].find(rail => rail.id === position.id); if (node) { node.scrollTop = position.top; node.scrollLeft = position.left; } });
    });
    restorePositions();
    requestAnimationFrame(restorePositions);
    synchronizeActual(actual, origin);
    document.querySelectorAll('[data-cf-display-warning]').forEach(node => { node.textContent = ''; node.hidden = true; node.removeAttribute('data-cf-display-warning'); });
    feedbackVisibility();
    syncControls();
  }
  async function refreshActual(origin = 'cart-refresh') {
    try {
      const actual = await getCart();
      await renderActual(actual, null, origin);
      return actual;
    } catch (error) {
      surfaces().forEach(surface => { surface.dataset.cfStale = 'true'; });
      syncControls();
      throw error;
    }
  }
  function revealFocusedDrawerTarget(target) {
    if (!target?.matches('[data-cf-quantity],[data-cf-adjust],[data-cf-remove]')) return;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (!drawer.open || !target.isConnected || document.activeElement !== target) return;
      const body = target.closest('.cf-cart-drawer__body');
      if (!body || !drawer.contains(body) || body.clientHeight <= 0) return;
      const viewport = body.getBoundingClientRect(), rect = target.getBoundingClientRect();
      const top = viewport.top + body.clientTop, bottom = top + body.clientHeight;
      const delta = rect.top < top ? rect.top - top - 6 : rect.bottom > bottom ? rect.bottom - bottom + 6 : 0;
      if (delta) body.scrollTop = Math.max(0, Math.min(body.scrollHeight - body.clientHeight, body.scrollTop + delta));
    }));
  }
  function focusAfterChange(key, kind, identity) {
    const scope = drawer.open ? drawer : document.querySelector('[data-cf-surface="page"]');
    if (!scope) return;
    let currentKey = key;
    if (identity && !cart?.items.some(item => item.key === key)) {
      const matches = (cart?.items || []).filter(item => lineIdentity(item) === identity);
      currentKey = matches.length === 1 ? matches[0].key : null;
    }
    const selectors = kind === 'input' ? '[data-cf-quantity]' : kind === 'remove' ? '[data-cf-remove]' : '[data-cf-adjust]';
    const target = [...scope.querySelectorAll(selectors)].find(node => node.dataset.cfKey === currentKey && (kind === 'input' || kind === 'remove' || node.dataset.cfAdjust === kind));
    if (!target && identity && !currentKey && kind !== 'remove') {
      const statusScope = drawer.open ? drawer : document;
      const status = [...statusScope.querySelectorAll('[data-cf-drawer-error],[data-cf-error],[data-cf-drawer-status],[data-cf-status]')].find(node => !node.hidden && node.textContent.trim());
      if (status) { status.tabIndex = -1; status.focus({ preventScroll: true }); return; }
    }
    const fallback = scope.querySelector('[data-cf-quantity],.empty-state a,a[href]');
    const focusTarget = target || fallback;
    focusTarget?.focus({ preventScroll: true });
    revealFocusedDrawerTarget(focusTarget);
  }
  async function mutate(name, payload, options = {}) {
    return enqueue(async () => {
      setBusy(true); clearErrors(); announce('');
      let response, actual, confirmed = false, rendered = false;
      try {
        try {
          response = await post(name, payload); confirmed = true;
          actual = isCart(response) ? response : await getCart();
          await renderActual(actual, response.sections, options.source || 'cart-update'); rendered = true;
        } catch (error) {
          if (!confirmed && name === 'add' && (!error.status || error.uncertain)) removal = null;
          try { actual = await refreshActual('cart-error-reconcile'); rendered = true; } catch { surfaces().forEach(surface => { surface.dataset.cfStale = 'true'; }); }
          if (!confirmed) {
            showError(error, options.form);
            if (error.uncertain || !rendered) appendCartFallback(options.form);
            options.failure?.(error);
            return null;
          }
        }
        try {
          const announceSuccess = rendered || isCart(actual) || name === 'add' ? await options.success?.(actual, response, { rendered }) : undefined;
          if (rendered) {
            if (announceSuccess !== false) announce(options.message || text('cartUpdated'));
          } else {
            if (isCart(actual)) synchronizeActual(actual, options.source || 'cart-update');
            if (announceSuccess !== false) showError(new Error(text(name === 'add' ? 'addedDisplayError' : 'updatedDisplayError', text('loadError'))), options.form);
            appendCartFallback(options.form, true);
          }
        } catch {
          showError(new Error(text(name === 'add' ? 'addedDisplayError' : 'updatedDisplayError', text('loadError'))), options.form);
          appendCartFallback(options.form, true);
        }
        return actual || null;
      } finally {
        setBusy(false);
        options.complete?.();
      }
    });
  }
  function changeQuantity(key, value, kind, input) {
    if (quantityRequests.get(key)?.value === value) return quantityRequests.get(key).promise;
    const item = cart?.items.find(line => line.key === key);
    if (item && Number(item.quantity) === value) return Promise.resolve(cart);
    const identity = lineIdentity(item);
    const backup = value === 0 && item ? { id: item.variant_id || item.id, quantity: item.quantity, properties: item.properties || {}, selling_plan: item.selling_plan_allocation?.selling_plan?.id || null } : null;
    const promise = mutate('change', { id: key, quantity: value }, {
      source: value === 0 ? 'cart-remove' : 'cart-quantity', message: value === 0 ? text('itemRemoved', text('cartUpdated')) : text('cartUpdated'),
      success: () => { if (backup) removal = backup; },
      complete: () => { quantityRequests.delete(key); focusAfterChange(key, kind, identity); }
    });
    quantityRequests.set(key, { value, promise });
    return promise;
  }
  const discountCodes = actual => {
    const codes = (actual?.discount_codes || []).map(discount => typeof discount === 'string' ? discount : discount.code);
    (actual?.discount_applications || []).forEach(discount => { if (discount.type === 'discount_code') codes.push(discount.title); });
    (actual?.cart_level_discount_applications || []).forEach(discount => { if (discount.type === 'discount_code') codes.push(discount.title); });
    (actual?.items || []).forEach(item => (item.line_level_discount_allocations || item.discount_allocations || []).forEach(allocation => { if (allocation.discount_application?.type === 'discount_code') codes.push(allocation.discount_application.title); }));
    return [...new Map(codes.filter(Boolean).map(code => [String(code).toLowerCase(), String(code)])).values()];
  };
  function changeDiscount(codes, submitted = []) {
    return mutate('update', { discount: codes.join(',') }, {
      source: 'cart-discount', success: actual => {
        const invalid = (actual.discount_codes || []).some(discount => submitted.some(code => String(discount.code).toLowerCase() === code.toLowerCase()) && discount.applicable === false);
        const applications = [...(actual.discount_applications || []), ...(actual.cart_level_discount_applications || []), ...(actual.items || []).flatMap(item => (item.line_level_discount_allocations || item.discount_allocations || []).map(allocation => allocation.discount_application))].filter(application => application?.type === 'discount_code');
        const unconfirmed = submitted.some(code => !(actual.discount_codes || []).some(discount => String(discount.code).toLowerCase() === code.toLowerCase() && discount.applicable === true) && !applications.some(application => String(application.title).toLowerCase() === code.toLowerCase()));
        if (invalid || unconfirmed) {
          const message = invalid ? text('discountInvalid', text('updateError')) : text('discountUnconfirmed', text('updateError'));
          showError(new Error(message));
          document.querySelectorAll('[data-cf-discount]').forEach(form => {
            if (form.closest('details')) form.closest('details').open = true;
            const input = form.querySelector('[name="discount"]'); if (input) input.value = submitted.join(',');
            setContent('[data-cf-discount-message]', message, false, form);
          });
          return false;
        }
      }
    });
  }
  async function closeOtherDialogs() {
    await Promise.all([...document.querySelectorAll('dialog[open]')].filter(node => node !== drawer).map(node => new Promise(resolve => { node.addEventListener('close', resolve, { once: true }); node.close(); })));
  }
  function lockScroll() {
    if (scrollState) return;
    const body = document.body;
    scrollState = { x: scrollX, y: scrollY, position: body.style.position, top: body.style.top, left: body.style.left, width: body.style.width, overflow: body.style.overflow, paddingRight: body.style.paddingRight };
    const padding = number(parseFloat(getComputedStyle(body).paddingRight));
    Object.assign(body.style, { position: 'fixed', top: `${-scrollState.y}px`, left: `${-scrollState.x}px`, width: '100%', overflow: 'hidden', paddingRight: `${padding + Math.max(0, innerWidth - document.documentElement.clientWidth)}px` });
  }
  function unlockScroll() {
    if (!scrollState) return;
    const saved = scrollState; scrollState = null;
    const { x, y, ...styles } = saved; Object.assign(document.body.style, styles);
    window.scrollTo({ left: x, top: y, behavior: 'instant' });
    requestAnimationFrame(() => { if (!drawer.open && !document.querySelector('dialog[open]')) window.scrollTo({ left: x, top: y, behavior: 'instant' }); });
  }
  function loading(value) {
    drawer.dataset.cfLoading = String(value);
    drawer.setAttribute('aria-busy', String(value));
    setContent('[data-cf-drawer-status]', value ? text('loading') : '', !value);
  }
  async function displayDrawer(trigger) {
    await closeOtherDialogs();
    if (!drawer.isConnected) return;
    opener = trigger?.isConnected ? trigger : document.querySelector('[data-cf-open]');
    opener?.setAttribute('aria-expanded', 'true');
    if (!drawer.open) { lockScroll(); drawer.hidden = false; drawer.setAttribute('aria-hidden', 'false'); drawer.showModal(); }
    feedbackVisibility();
    scheduleSticky();
  }
  async function openDrawer(trigger, alreadyFresh = false) {
    const generation = ++openRequest;
    await displayDrawer(trigger);
    if (generation !== openRequest || !drawer.open) return;
    if (alreadyFresh) { loading(false); drawer.querySelector('[data-cf-close],button,a')?.focus({ preventScroll: true }); return; }
    loading(true); setContent('[data-cf-drawer-error]', '', true);
    drawer.querySelectorAll('[data-cf-retry]').forEach(button => { button.hidden = true; });
    await enqueue(async () => {
      setBusy(true);
      try { await refreshActual('cart-open'); }
      catch (error) { showError(error); appendCartFallback(null, true); drawer.querySelectorAll('[data-cf-retry]').forEach(button => { button.hidden = false; }); }
      finally { setBusy(false); if (generation === openRequest) loading(false); }
    });
  }
  function synchronizeSticky() {
    stickyFrame = 0;
    let visible = false, height = 0, visibilityChanged = false;
    document.querySelectorAll('[data-cf-sticky]').forEach(sticky => {
      const page = document.querySelector('[data-cf-surface="page"]');
      const primary = page ? [...page.querySelectorAll('[name="checkout"]')].find(button => !button.closest('[data-cf-sticky]')) : null;
      const rect = primary?.getBoundingClientRect();
      const primaryVisible = rect && rect.bottom > 0 && rect.top < innerHeight - 80;
      const overlay = Boolean(document.querySelector('dialog[open]'));
      const wasHidden = sticky.hidden;
      sticky.hidden = !matchMedia('(max-width:767px)').matches || number(cart?.item_count, number(page?.dataset.cfCount)) === 0 || Boolean(primaryVisible) || overlay;
      visibilityChanged ||= wasHidden !== sticky.hidden;
      if (!sticky.hidden) { visible = true; height = Math.max(height, Math.ceil(sticky.getBoundingClientRect().height)); }
    });
    document.documentElement.style.setProperty('--cf-cart-sticky-height', `${height}px`);
    if (visibilityChanged || stickyLayout.visible !== visible || stickyLayout.height !== height) {
      stickyLayout = { visible, height };
      document.dispatchEvent(new CustomEvent('drpenx:cart-sticky-layout', { detail: { ...stickyLayout } }));
    }
  }
  function scheduleSticky() { if (!stickyFrame) stickyFrame = requestAnimationFrame(synchronizeSticky); }
  document.addEventListener('click', event => {
    const target = event.target.closest?.('[data-cf-open],[data-cf-close],[data-cf-retry],[data-cf-adjust],[data-cf-remove],[data-cf-undo],[data-cf-remove-discount],[data-cf-reco-prev],[data-cf-reco-next],[data-cf-dismiss]');
    if (!target) return;
    if (target.matches('[data-cf-open]')) {
      if (event.button > 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault(); openDrawer(target); return;
    }
    if (target.matches('[data-cf-close]')) { event.preventDefault(); drawer.close(); return; }
    if (target.matches('[data-cf-dismiss]')) { event.preventDefault(); target.closest('[data-cf-feedback]')?.setAttribute('hidden', ''); return; }
    if (target.matches('[data-cf-retry]')) { event.preventDefault(); if (!busy) openDrawer(opener); return; }
    if (target.matches('[data-cf-reco-prev],[data-cf-reco-next]')) {
      const id = target.getAttribute('aria-controls');
      const rail = (id && document.getElementById(id)) || target.closest('.recommendation-group,[data-cf-recommendations]')?.querySelector('.reco-rail,[data-cf-reco-rail]');
      if (rail) { event.preventDefault(); const direction = target.matches('[data-cf-reco-prev]') ? -1 : 1; rail.scrollBy({ left: direction * (getComputedStyle(rail).direction === 'rtl' ? -1 : 1) * rail.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth' }); }
      return;
    }
    event.preventDefault();
    if (busy || target.closest('[data-cf-stale="true"]')) return;
    if (target.matches('[data-cf-undo]')) {
      if (!removal || undoPending) return;
      undoPending = true;
      const payload = { ...removal }; if (!payload.selling_plan) delete payload.selling_plan;
      mutate('add', payload, { source: 'cart-undo', success: () => { removal = null; }, failure: error => showError(new Error(text('undoError', error.message))), complete: () => { undoPending = false; } });
      return;
    }
    if (target.matches('[data-cf-remove-discount]')) {
      const code = target.dataset.cfCode, codes = discountCodes(cart);
      if (code && codes.some(value => value.toLowerCase() === code.toLowerCase())) changeDiscount(codes.filter(value => value.toLowerCase() !== code.toLowerCase()));
      return;
    }
    const key = target.dataset.cfKey, input = [...(target.closest('[data-cf-surface]') || document).querySelectorAll('[data-cf-quantity]')].find(node => node.dataset.cfKey === key);
    if (!key) return;
    if (target.matches('[data-cf-remove]')) { changeQuantity(key, 0, 'remove', input); return; }
    if (!input) return;
    const value = number(input.value) + Number(target.dataset.cfAdjust) * rules(input).step;
    if (validQuantity(input, value)) changeQuantity(key, value, target.dataset.cfAdjust, input);
  });
  document.addEventListener('change', event => {
    const input = event.target.closest?.('[data-cf-quantity]');
    if (!input || busy) return;
    const value = Number(input.value);
    if (!validQuantity(input, value)) { input.value = input.defaultValue; input.setCustomValidity(text('quantityInvalid')); input.reportValidity(); showError(new Error(text('quantityInvalid'))); return; }
    input.setCustomValidity(''); changeQuantity(input.dataset.cfKey, value, 'input', input);
  });
  document.addEventListener('input', event => { if (event.target.matches?.('[data-cf-quantity]')) event.target.setCustomValidity(''); });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || event.defaultPrevented) return;
    const submitter = event.submitter;
    if (submitter?.name === 'checkout' || submitter?.closest('.quick-buy-native,shopify-accelerated-checkout,.shopify-payment-button')) return;
    if (form.matches('[data-cf-discount]')) {
      event.preventDefault(); if (busy) return;
      const input = form.querySelector('[name="discount"]');
      const submitted = (input?.value || '').split(',').map(value => value.trim()).filter(Boolean);
      if (!submitted.length) { input?.focus(); return; }
      const codes = [...new Map([...discountCodes(cart), ...submitted].map(code => [code.toLowerCase(), code])).values()];
      changeDiscount(codes, submitted); return;
    }
    if (form.matches('[data-cf-cart-form]')) {
      event.preventDefault(); if (busy) return;
      form.querySelectorAll('[data-cf-quantity]').forEach(input => { const value = Number(input.value); if (validQuantity(input, value)) changeQuantity(input.dataset.cfKey, value, 'input', input); else { input.setCustomValidity(text('quantityInvalid')); input.reportValidity(); } });
      return;
    }
    if (form.getAttribute('id') !== 'purchase-form' || form.dataset.cfCartAdapter !== 'true' || submitter?.name !== 'add' || adding.has(form)) return;
    event.preventDefault(); adding.add(form);
    const payload = new FormData(form);
    mutate('add', payload, {
      source: 'product-form', form, message: text('addedToCart', text('cartUpdated')),
      success: async (_actual, response, { rendered = true } = {}) => {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: response.items?.[0] || response } }));
        if (rendered) await openDrawer(submitter, true);
      },
      complete: () => { adding.delete(form); form.dispatchEvent(new CustomEvent('drpenx:cart-add-complete', { bubbles: false })); }
    });
  });
  drawer.addEventListener('close', () => {
    ++openRequest; loading(false); drawer.hidden = true; drawer.setAttribute('aria-hidden', 'true');
    opener?.setAttribute('aria-expanded', 'false'); unlockScroll();
    if (!document.querySelector('dialog[open]')) opener?.focus({ preventScroll: true });
    scheduleSticky();
    feedbackVisibility();
  });
  drawer.addEventListener('click', event => {
    if (event.target !== drawer) return;
    const rect = drawer.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) drawer.close();
  });
  document.addEventListener('cart:refresh', event => { if (event.detail?.open) openDrawer(document.activeElement); else enqueue(async () => { setBusy(true); try { await refreshActual('external-cart-refresh'); } catch (error) { showError(error); } finally { setBusy(false); } }); });
  document.addEventListener('shopify:section:load', () => { syncControls(); scheduleSticky(); });
  function scheduleLifecycleRefresh() {
    if (document.visibilityState === 'hidden' || !drawer.open && !document.querySelector('[data-cf-surface="page"]')) return;
    if (lifecyclePending) { lifecycleDirty = true; return; }
    if (lifecycleTimer) return;
    lifecycleTimer = setTimeout(() => {
      lifecycleTimer = 0;
      if (document.visibilityState === 'hidden' || !drawer.open && !document.querySelector('[data-cf-surface="page"]')) return;
      lifecyclePending = true;
      enqueue(async () => {
        try {
          if (document.visibilityState === 'hidden' || !drawer.open && !document.querySelector('[data-cf-surface="page"]')) return;
          setBusy(true);
          try { await refreshActual('cart-lifecycle-refresh'); }
          catch (error) {
            surfaces().forEach(surface => { surface.dataset.cfStale = 'true'; });
            showError(error); appendCartFallback(null, true);
          }
          finally { setBusy(false); }
        } finally {
          lifecyclePending = false;
          if (lifecycleDirty) { lifecycleDirty = false; scheduleLifecycleRefresh(); }
        }
      });
    }, 32);
  }
  window.addEventListener('pageshow', event => { syncControls(); scheduleSticky(); if (event.persisted) scheduleLifecycleRefresh(); });
  window.addEventListener('focus', scheduleLifecycleRefresh);
  document.addEventListener('visibilitychange', scheduleLifecycleRefresh);
  window.addEventListener('scroll', scheduleSticky, { passive: true });
  window.addEventListener('resize', scheduleSticky);
  document.addEventListener('toggle', scheduleSticky, true);
  new ResizeObserver(scheduleSticky).observe(document.body);
  if (!drawer.open) { drawer.hidden = true; drawer.setAttribute('aria-hidden', 'true'); }
  syncControls(); scheduleSticky();
  document.documentElement.dataset.cfCartReady = 'true';
  window.DrpenxCartFinal = { ready: true, open: trigger => openDrawer(trigger), refresh: () => enqueue(async () => { setBusy(true); try { return await refreshActual('cart-api-refresh'); } finally { setBusy(false); } }) };
})();
